<template>
    <Dialog v-model="state" :scrollable="false" @close="$emit('close')">
        <div class="mobile-choose" v-loading="loading">
            <div class="mobile-choose__title">
                Рассылка пользователям
            </div>
            <div class="mobile-choose__footer">
                <button class="button button-blue button-outline" @click="$emit('submit', 'email')">
                    <EmailIcon class="icon" /> <span>E-mail рассылка</span>
                </button>
                <button class="button button-blue button-outline" @click="$emit('submit', 'push')">
                    <PhoneIcon class="icon" /> <span>Push-уведомления</span>
                </button>
            </div>
        </div>
    </Dialog>
</template>

<script>
import Dialog from '@/components/UI/Dialog';
import EmailIcon from '@/assets/images/user-search/popup/email.svg?inline';
import PhoneIcon from '@/assets/images/user-search/popup/phone.svg?inline';

export default {
    name: "UserSearchNotificationMobileChoose",

    components: {
        Dialog,
        EmailIcon,
        PhoneIcon,
    },

    emits: [ "close", "submit" ],

    props: {
        loading: Boolean,
    },

    data: () => ({
        state: true,
    }),

    beforeMount() {
        this.state = true;
    },

    watch: {
        state(val) {
            if (!val) {
                this.$emit("close");
            }
        },
    },
};
</script>

<style scoped lang="scss">
@import '~@/styles/rem';
@import '~@/styles/variables';
@import '~@/styles/buttons_v2';

.mobile-choose {
    padding: urem(12);
    @include on-desktop {
        padding: 0;
        width: urem(680);
    }
    &__title {
        text-align: center;
        margin: 0 0 urem(40) 0;

        @include set-font-size(18, 700, 24);

        @include on-desktop {
            @include set-font-size(26, 700, 30);
        }
    }

    &__footer {
        display: flex;
        flex-direction: column-reverse;

        @include on-desktop {
            margin: 0 auto;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            gap: urem(24);
        }

        .button {
            gap: urem(6);
            padding-left: urem(32);
            padding-right: urem(32);
            @include set-font-size(14, 600, 20);

            .icon {
                width: urem(20);
            }
        }
    }
}
</style>
